import { AppError } from "@/core/common/http/errors/app.error";

export class BadRequestError extends AppError {
  constructor(message: string, url: string) {
    super(message, 400, "Bad Request", url, "Algún dato introducido es incorrecto");
  }
}
